<div class="slds-spinner_container">
    <div role="status" class="slds-spinner slds-spinner_{{size}}
     {{variant ? 'slds-spinner_' + variant : ''}}">
      <span class="slds-assistive-text">{{alternativeText}}</span>
      <div class="slds-spinner__dot-a"></div>
      <div class="slds-spinner__dot-b"></div>
    </div>
  </div>
